interface ResizeHandleProps {
  onResize: (deltaY: number) => void;
}

export function ResizeHandle({ onResize }: ResizeHandleProps) {
  function handleDrag(e: React.DragEvent) {
    if (e.clientY === 0) return; // Ignore invalid coordinates
    onResize(e.movementY);
  }

  return (
    <div
      draggable
      onDrag={handleDrag}
      className="absolute bottom-0 left-0 right-0 h-2 cursor-ns-resize bg-black/10 hover:bg-black/20 rounded-b-md z-10"
      data-testid="resize-handle"
      onClick={(e) => e.stopPropagation()} // Prevent event click when interacting with handle
    />
  );
}
